import React from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import "../styles/AdminNewPass.css"
// import {Link} from "react-router-dom";
import { useHistory } from 'react-router-dom'

function MembershipFormVedio() {
    const history = useHistory()
    const result2 = JSON.parse(localStorage.getItem("type"))
    const handlestep = () => {
        history.push('/membership/signup')
    }



    return (

        <>
            <div className="appHome" style={{ marginLeft: '350px' }}>
                <h2>NMO Membership: A Video Guide</h2>
                {result2==='single'?<iframe width="560" height="315" src="https://www.youtube.com/embed/XNtwolBuM74" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>:result2==='couple'?<iframe width="560" height="315" src="https://www.youtube.com/embed/3xxU-ywML6E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>:<iframe width="560" height="315" src="https://www.youtube.com/embed/S8QNcH5k2iE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>}
                
            </div>

	               <p
  style={{
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '0rem 2rem 1rem 2rem',
    padding: '1rem 2rem',
    backgroundColor: '#fff3cd',
    textAlign: 'center',
    border: '2px solid #ffc107',
    borderRadius: '8px',
    color: '#856404',
    animation: 'textBlink 2s ease-in-out infinite',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  }}
>
  Note: Processing turn around time for digital membership is 15 days if documents are in place and Physical copy will reach to member within 1.5 month after confirmation of digital membership.
</p>
<style jsx>{`
        @keyframes textBlink {
          0%, 100% {
            color: #856404;
            border-color: #ffc107;
          }
          50% {
            color: #d39e00;
            border-color: #ffd54f;
          }
        }
      `}</style>
            <Button variant="contained" color="primary" onClick={handlestep} style={{ marginLeft: '600px' }}>Next</Button>

        </>

    )
}



export default MembershipFormVedio;
